import { Component } from 'react';
import {connect} from 'react-redux';
import {actions} from 'forms/rrf';
import {Link} from 'react-router-dom';
import {Container} from 'react-bootstrap';
import CategoriesList from './categories-list';
import ProductSearchComponent from '../../../../common/search/simple-search-component';
import PageTitle from '../../../../common/page-title/index';
import ArrowButton from '../../../../common/button-arrow';
import {getCategories} from '../../../../../actions/categories';

import '../../common/styles.css';

class Categories extends Component {
  state = {
    query: ''
  };
  handleInputChange = (e) => {
    this.setState({query: e.target.value});
  };
  handleSearch = () => {
    const {query} = this.state;
    this.props.dispatch(getCategories(query));
  };
  handleClear = () => {
    this.setState({query: ''}, this.handleSearch);
  };

  UNSAFE_componentWillMount() {
    this.props.dispatch(actions.reset('deep.admin_category'));
    this.props.dispatch({type: 'CLEAR_EDIT_CATEGORY'});
    this.props.dispatch(getCategories());
  }

  render() {
    return (
      <Container fluid className="products">
        <PageTitle>
          Categories
        </PageTitle>
        <Link to="/admin/categories/new">
          <ArrowButton
            arrow={false}
            className="add-product"
            color="red"
            permissions={{
              action: 'create',
              subjectClass: 'Category'
            }}
            submit={false}
          >
            Add category
          </ArrowButton>
        </Link>

        <ProductSearchComponent
          onClear={this.handleClear}
          onInputChange={this.handleInputChange}
          onSearch={this.handleSearch}
          searchValue={this.state.query}
        />
        <CategoriesList
          categories={this.props.categories}
          fetched={this.props.fetched}
          fetching={this.props.fetching}
          onReorder={this.handleSearch}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  categories: state.categories.categories,
  fetched: state.categories.fetched,
  fetching: state.categories.fetching,
});

export default connect(mapStateToProps)(Categories);
